/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { AppState } from '@app/core/types';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const errorActions = createFeatureSelector<AppState['errorActions']>('errorActions');

export const snackbarDurationSelector = createFeatureSelector<AppState['snackbarDuration']>('snackbarDuration');
export const errorSnackbarDurationSelector = createSelector(snackbarDurationSelector, (state) => state.error);
export const notificationSnackbarDurationSelector = createSelector(
  snackbarDurationSelector,
  (state) => state.notification,
);
